module.exports = __webpack_public_path__ + "static/wpack/extracted/hand-get5db526cc4fe39c6d3c1df2cfac873833.svg";